<div class="group-by-dropdown">
  <label class="group-by-label">{{ "GROUP_BY.GROUP_BY" | translate }}</label>

  <p-multiSelect
    styleClass="group-by-select"
    [panelStyleClass]="'group-by-select-panel ' + panelClassName"
    [options]="groupByOptions"
    optionLabel="label"
    optionValue="value"
    placeholder="{{ 'GROUP_BY.GROUP_BY_PLACEHOLDER' | translate }}"
    appendTo="body"
    [(ngModel)]="selectedGroupBy"
    (onChange)="onGroupByChange()"
    [display]="'chip'"
    [showToggleAll]="false"
    [showClear]="false"
  >
  </p-multiSelect>
</div>
